import React, { useState } from "react";

const NewServiceSettings = () => {
  const [requirePatchTest, setRequirePatchTest] = useState(false);
  const [aftercareInstructions, setAftercareInstructions] = useState(false);
  const [reminderRebook, setReminderRebook] = useState(false);

  const [salesTax, setSalesTax] = useState("All default");
  const [costOfService, setCostOfService] = useState("");
  const [sku, setSku] = useState("");

  return (
    <div className="space-y-10">
      {/* General settings */}
      <section>
        <h2 className="text-lg font-semibold mb-4">General settings</h2>
        <label className="flex items-start gap-3 cursor-pointer mb-3">
          <input
            type="checkbox"
            checked={requirePatchTest}
            onChange={() => setRequirePatchTest(!requirePatchTest)}
            className="mt-1 h-4 w-4 rounded border-gray-300 text-purple-600 focus:ring-purple-500"
          />
          <span>
            <span className="font-medium">Require patch test</span>
            <p className="text-sm text-gray-500">
              Show a patch test requirement when creating appointments with this
              service.
            </p>
          </span>
        </label>
      </section>

      {/* Notifications */}
      <section>
        <h2 className="text-lg font-semibold mb-4">Notifications</h2>

        <label className="flex items-start gap-3 cursor-pointer mb-3">
          <input
            type="checkbox"
            checked={aftercareInstructions}
            onChange={() => setAftercareInstructions(!aftercareInstructions)}
            className="mt-1 h-4 w-4 rounded border-gray-300 text-purple-600 focus:ring-purple-500"
          />
          <span>
            <span className="font-medium">Aftercare instructions</span>
            <p className="text-sm text-gray-500">
              Provide aftercare instructions to clients in thank you
              notifications.
            </p>
          </span>
        </label>

        <label className="flex items-start gap-3 cursor-pointer">
          <input
            type="checkbox"
            checked={reminderRebook}
            onChange={() => setReminderRebook(!reminderRebook)}
            className="mt-1 h-4 w-4 rounded border-gray-300 text-purple-600 focus:ring-purple-500"
          />
          <span>
            <span className="font-medium">
              Reminder to rebook notifications
            </span>
            <p className="text-sm text-gray-500">
              Choose when you would like to notify your clients to rebook this
              service.
            </p>
          </span>
        </label>
      </section>

      {/* Advanced settings */}
      <section>
        <h2 className="text-lg font-semibold mb-4">Advanced settings</h2>

        {/* Sales Tax */}
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Sales tax <span className="text-gray-400">(Included in price)</span>
          </label>
          <div className="flex items-center justify-between border rounded-md px-3 py-2 text-sm">
            <span>{salesTax}</span>
            <button className="text-purple-600 hover:underline text-sm">
              Edit
            </button>
          </div>
          <p className="text-xs text-gray-400 mt-1">
            Configure sales tax settings for each of your locations
          </p>
        </div>

        {/* Cost of Service */}
        <div className="mb-6 max-w-xs">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Cost of service
          </label>
          <div className="flex gap-2">
            <input
              type="number"
              value={costOfService}
              onChange={(e) => setCostOfService(e.target.value)}
              placeholder="NZ$ 0.00"
              className="flex-1 border rounded-md px-3 py-2 text-sm"
            />
            <button className="px-3 py-2 border rounded-md">💰</button>
            <button className="px-3 py-2 border rounded-md">%</button>
          </div>
          <p className="text-xs text-gray-400 mt-1">
            Set the cost to your business for delivering this service
          </p>
        </div>

        {/* SKU */}
        <div className="mb-6 max-w-xs">
          <label className="block text-sm font-medium text-gray-700 mb-1">
            SKU
          </label>
          <input
            type="text"
            value={sku}
            onChange={(e) => setSku(e.target.value)}
            placeholder="ABC-12345-H-SH"
            maxLength={20}
            className="w-full border rounded-md px-3 py-2 text-sm"
          />
          <p className="text-xs text-gray-400 mt-1">
            Assign a SKU to help identify this service in reports and exports
          </p>
          <p className="text-xs text-gray-400 text-right">{sku.length}/20</p>
        </div>
      </section>
    </div>
  );
};

export default NewServiceSettings;
